import Link from 'next/link'
import React from 'react'

import { Button } from '@/shared/ui'

import { guaranteeItems, guaranteeNotation } from '../../data'

import cls from './BeSureBlock.module.scss'

const BeSureBlock = () => {
	const data = guaranteeItems[0]
	return (
		<section className={cls.BeSure}>
			<div className={cls.BeSure__mainContentContainer}>
				<div className={cls.BeSure__textWrapper}>
					<h2 className={cls.BeSure__title}>{data.title}</h2>
					<p className={cls.BeSure__subtitle}>{data.subtitle}</p>
				</div>
				<ul className={cls.BeSure__list}>
					{data.textItems.map((item, index) => (
						<li className={cls.BeSure__item} key={index}>
							<item.image size={48} className={cls.BeSure__svg} />
							<div className={cls.BeSure__itemTextWrapper}>
								<h3 className={cls.BeSure__itemTitle}>{item.title}</h3>
								<p className={cls.BeSure__itemSubtitle}>{item.subtitle}</p>
							</div>
						</li>
					))}
				</ul>
			</div>
			<div className={cls.BeSure__notationContainer}>
				<p className={cls.BeSure__notationText}>{guaranteeNotation.subtitle}</p>
				<Link prefetch={false} href={guaranteeNotation.link.href}>
					{/* @next-codemod-error This Link previously used the now removed `legacyBehavior` prop, and has a child that might not be an anchor. The codemod bailed out of lifting the child props to the Link. Check that the child component does not render an anchor, and potentially move the props manually to Link. */}
					<Button className={cls.BeSure__btn}>{guaranteeNotation.link.text}</Button>
				</Link>
			</div>
		</section>
	)
}

export default BeSureBlock
